/** Base de las bajas: envía la baja por gRPC-Web (`sendDelete`) y la refleja en el listado. */
export abstract class ServiceDeleteBase {
  /** Servicio de listado del que hay que sacar el registro borrado. */
  protected readonly cache?: { remove(id: string): void };

  /** Da de baja el registro y, si hay listado asociado (`cache`), lo saca de la lista en memoria. */
  async delete(id: string): Promise<void> {
    await this.sendDelete(id);
    this.cache?.remove(id);
  }

  /** Llamada gRPC-Web de la baja. El `remove` queda en `delete()`. */
  protected abstract sendDelete(id: string): Promise<void>;
}
